<template>
  <div class="app-modal">
    <div class="modal-content">
      <div class="header">
        <div class="title-with-close">
          <img class="close-mobile" src="@/assets/app-icons/profile/back.svg" @click="$emit('close')" />
          <span class="subtitle">Lozinka</span>
          <span class="close" @click="$emit('close')"></span>
        </div>
      </div>
      <form class="form" @submit.prevent="changePassword()" novalidate="true">
        <div class="input">
          <template v-if="oldPasswordShown">
            <input id="old-password" type="text" v-model="oldPassword" />
          </template>
          <template v-else>
            <input id="old-password" type="password" v-model="oldPassword" />
          </template>
          <label for="old-password" v-bind:class="oldPassword ? 'field-filled' : ''">Trenutna lozinka</label>
          <template v-if="oldPasswordShown">
            <img
              src="@/assets/app-icons/profile/hide-password.svg"
              class="visibility"
              @click="oldPasswordShown = false"
            />
          </template>
          <template v-else>
            <img
              src="@/assets/app-icons/profile/show-password.svg"
              class="visibility show"
              @click="oldPasswordShown = true"
            />
          </template>
        </div>
        <div class="input">
          <template v-if="newPasswordShown">
            <input
              id="new-password"
              v-bind:class="isNewPasswordValid ? '' : 'password-error'"
              type="text"
              v-model="newPassword"
              @change="validateNewPassword"
            />
          </template>
          <template v-else>
            <input
              id="new-password"
              v-bind:class="isNewPasswordValid ? '' : 'password-error'"
              type="password"
              v-model="newPassword"
              @change="validateNewPassword"
            />
          </template>
          <label for="new-password" v-bind:class="newPassword ? 'field-filled' : ''">Nova lozinka</label>
          <template v-if="newPasswordShown">
            <img
              src="@/assets/app-icons/profile/hide-password.svg"
              class="visibility"
              @click="newPasswordShown = false"
            />
          </template>
          <template v-else>
            <img
              src="@/assets/app-icons/profile/show-password.svg"
              class="visibility show"
              @click="newPasswordShown = true"
            />
          </template>
          <div class="error" :style="{ visibility: isNewPasswordValid ? 'hidden' : 'visible' }">
            Lozinka nije valjana. Mora imati bar 8 znakova, jedno veliko slovo i jedan broj.
          </div>
        </div>
        <div class="input">
          <template v-if="newPasswordShown">
            <input
              id="repeated-new-password"
              :class="isRepeatedNewPasswordValid ? '' : 'password-error'"
              type="text"
              v-model="repeatedNewPassword"
              @change="validateRepeatedNewPassword"
            />
          </template>
          <template v-else>
            <input
              id="repeated-new-password"
              :class="isRepeatedNewPasswordValid ? '' : 'password-error'"
              type="password"
              v-model="repeatedNewPassword"
              @change="validateRepeatedNewPassword"
            />
          </template>
          <label for="repeated-new-password" :class="repeatedNewPassword ? 'field-filled' : ''">
            Ponovi novu lozinku
          </label>
          <div class="error" :style="{ visibility: isRepeatedNewPasswordValid ? 'hidden' : 'visible' }">
            Lozinke se ne poklapaju.
          </div>
        </div>
        <div class="result" :style="{ visibility: changeWasntSuccessful ? 'visible' : 'hidden' }">
          Zahtjev za promjenom neuspješan. Molimo te pokušaj ponovo.
        </div>
        <div class="actions">
          <button class="cancel-button" type="button" @click="$emit('close')">Odustani</button>
          <button class="change-button" type="submit" value="submit" :disabled="passwordFormInvalid">
            Spremi
          </button>
        </div>
      </form>
    </div>
    <a aria-label="Zatvori popup" class="backdrop" @click="$emit('close')"></a>
  </div>
</template>

<script>
export default {
  name: 'ChangePasswordModal',
  data() {
    return {
      oldPassword: '',
      oldPasswordShown: false,
      newPassword: '',
      newPasswordShown: false,
      repeatedNewPassword: '',
      isNewPasswordValid: true,
      isRepeatedNewPasswordValid: true,
      changeWasntSuccessful: false,
    };
  },
  computed: {
    passwordFormInvalid: function() {
      return (
        !this.oldPassword ||
        !this.oldPassword.length ||
        this.oldPassword.length < 8 ||
        !this.newPassword ||
        !this.newPassword.length ||
        !this.isNewPasswordValid ||
        !this.repeatedNewPassword ||
        !this.repeatedNewPassword.length ||
        !this.isRepeatedNewPasswordValid ||
        this.repeatedNewPassword !== this.newPassword
      );
    },
  },
  methods: {
    validateNewPassword: function() {
      this.isNewPasswordValid =
        this.newPassword &&
        this.newPassword.length >= 8 &&
        this.newPassword.toLowerCase() !== this.newPassword &&
        /\d/.test(this.newPassword);
    },
    validateRepeatedNewPassword: function() {
      this.isRepeatedNewPasswordValid =
        this.newPassword && this.repeatedNewPassword && this.repeatedNewPassword === this.newPassword;
    },
    changePassword: function() {
      if (this.passwordFormInvalid || this.newPassword !== this.repeatedNewPassword) return;

      this.$axios
        .post(`${this.$API_URL}/user/change-password`, {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
        })
        .then(() => {
          this.oldPassword = null;
          this.newPassword = null;
          this.repeatedNewPassword = null;
          this.$emit('close', true);
        })
        .catch(() => {
          this.changeWasntSuccessful = true;
          setTimeout(() => (this.changeWasntSuccessful = false), 3000);
        });
    },
  },
};
</script>

<style scoped>
.subtitle {
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
}

.modal-content .form .input {
  position: relative;
  width: 100%;
  margin-bottom: 15px;
}

.modal-content .form .input:nth-of-type(1) {
  margin-bottom: 32px;
}

.modal-content .form .input input {
  border: none;
  border-bottom: 1.5px solid #7a8e94;
  font-size: 20px;
  padding: 25px 25px 10px 0;
  color: white;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  width: 100%;
  outline: none;
  background: transparent;
  transition: border-bottom 0.2s ease-in-out;
  box-sizing: border-box;
}

.modal-content .form .input input.password-error {
  color: #d73246;
  border-bottom-color: #d73246;
}

.modal-content .form .input input:focus {
  border-bottom: 1.5px solid #30cec2;
  color: #30cec2;
}

.modal-content .form .input label {
  position: absolute;
  color: white;
  font-size: 20px;
  left: 0;
  top: 25px;
  transition: all 0.1s ease;
}

.modal-content .form .input input:focus + label,
.modal-content .form .input label.field-filled {
  font-size: 16px;
  top: 0;
}

.modal-content .form .input .visibility {
  position: absolute;
  right: 0;
  top: 28px;
  filter: grayscale(1) brightness(100);
}

.modal-content .form .input .visibility.show {
  top: 30px;
}

.modal-content .form .input .visibility:hover {
  cursor: pointer;
}

.modal-content .form .input .error {
  margin-top: 5px;
  font-size: 14px;
  color: #d73246;
  font-weight: normal;
}

.modal-content .form .result {
  font-size: 14px;
  color: #d73246;
}

.modal-content .form .actions {
  display: flex;
  justify-content: flex-end;
}

.modal-content .form .actions .cancel-button {
  padding: 12px 32px;
  border-radius: 15px;
  margin-right: 8px;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.8);
  cursor: pointer;
}

.modal-content .form .actions .change-button {
  padding: 12px 32px;
  border-radius: 15px;
  margin-right: 8px;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  background-color: #30cec2;
  color: #000000;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
}

.modal-content .form .actions .change-button:hover {
  background-color: #35e5d8;
}

.modal-content .form .actions .change-button:disabled {
  cursor: initial;
  opacity: 0.4;
}
</style>
